if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-slides]');
      this.slides = this.viewport ? Array.from(this.viewport.children) : [];
      if (!this.viewport || this.slides.length < 2) return;

      this.index = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayWanted = this.dataset.autoplay === 'true' && !this.reduceMotion;

      this.onScroll = this.handleScroll.bind(this);

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));

      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      // WCAG: bewegte Inhalte müssen anhaltbar sein
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('touchstart', () => this.stop(), { passive: true });

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.viewport?.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      if (!this.autoplayWanted || this.timer || document.hidden) return;
      this.timer = setInterval(() => this.step(1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    step(direction) {
      const next = (this.index + direction + this.slides.length) % this.slides.length;
      this.goTo(next);
      // Nach einem Klick nicht sofort weiterspringen
      if (this.timer) {
        this.stop();
        this.start();
      }
    }

    goTo(index) {
      this.index = index;
      this.viewport.scrollTo({
        left: this.viewport.clientWidth * index,
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    handleScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        const width = this.viewport.clientWidth;
        if (!width) return;
        // Wischen hält den Index synchron, sonst springt der nächste Autoplay-Schritt
        this.index = Math.round(this.viewport.scrollLeft / width);
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
